/* WSNZ Database v3 runtime. Load after setting window.WSNZ_DATABASE_URL. */
(function () {
  "use strict";
  const api = window.WSNZ || {};
  let database = null;

  async function load(url) {
    const source = url || window.WSNZ_DATABASE_URL;
    if (!source) throw new Error("WSNZ_DATABASE_URL is not configured.");
    const response = await fetch(source, { credentials: "same-origin" });
    if (!response.ok) throw new Error(`WSNZ database failed to load: ${response.status}`);
    database = await response.json();
    localStorage.setItem(database.configuration.storage.versionKey, database.schemaVersion);
    window.dispatchEvent(new CustomEvent(database.configuration.events.databaseReady, { detail: { database } }));
    return database;
  }
  function requireDb(){ if(!database) throw new Error("WSNZ database is not loaded."); return database; }
  function getDatabase(){ return requireDb(); }
  function getKingdom(id){ return requireDb().kingdoms[id] || null; }
  function getKingdoms(){ const d=requireDb(); return d.orders.kingdoms.map(id=>d.kingdoms[id]).filter(Boolean); }
  function getDiscoveryById(id){ return requireDb().discoveries[id] || null; }
  function getDiscoveries(filters={}){
    const d=requireDb(); let ids=d.orders.discoveries.slice();
    if(filters.kingdomId) ids=d.indexes.discoveriesByKingdom[filters.kingdomId] || [];
    if(filters.type) ids=ids.filter(id=>d.discoveries[id]?.type===filters.type);
    if(filters.rarity) ids=ids.filter(id=>String(d.discoveries[id]?.rarity).toLowerCase()===String(filters.rarity).toLowerCase());
    return ids.map(id=>d.discoveries[id]).filter(Boolean);
  }
  function getJournal(id){ return requireDb().journals[id] || null; }
  function getJournalsByKingdom(kingdomId){ const d=requireDb(); return (d.indexes.journalsByKingdom[kingdomId]||[]).map(id=>d.journals[id]); }
  function getUnlockedIds(){ const d=requireDb(); try{return JSON.parse(localStorage.getItem(d.configuration.storage.unlockedDiscoveriesKey)||"[]");}catch{return [];} }
  function isUnlocked(id){ return getUnlockedIds().includes(id); }
  function unlockDiscovery(id){
    const d=requireDb(); if(!d.discoveries[id]) return false;
    const ids=getUnlockedIds(); if(ids.includes(id)) return false;
    ids.push(id); localStorage.setItem(d.configuration.storage.unlockedDiscoveriesKey,JSON.stringify(ids));
    window.dispatchEvent(new CustomEvent(d.configuration.events.discoveryUnlocked,{detail:{id,discovery:d.discoveries[id]}}));
    return true;
  }
  function getProgress(){
    const d=requireDb(), total=d.orders.discoveries.length, found=getUnlockedIds().filter(id=>d.discoveries[id]).length;
    return {total,found,hidden:Math.max(total-found,0),percent:total?Math.round(found/total*100):0};
  }
  Object.assign(api,{load,getDatabase,getKingdom,getKingdoms,getDiscoveryById,getDiscoveries,getJournal,getJournalsByKingdom,getUnlockedIds,isUnlocked,unlockDiscovery,getProgress});
  window.WSNZ=api;
})();
